import React, { FC } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { Divider } from '@moonpig/launchpad-components'
import { DepartmentTab } from './Tab'
import { DepartmentType } from '../departmentMap'
import { DepartmentTabItemType } from '../types'

type DepartmentTabsProps = {
  selectedDepartment: DepartmentType
  departments: DepartmentType[]
  highlightedIndex: number | null
  storeId: string
  setHighlightedIndex: (index: number) => void
  setActiveDepartment: (department: DepartmentType) => void
  getItemProps: (props: {
    itemIndex: number
    item: DepartmentTabItemType
  }) => Record<string, unknown>
} & React.HTMLProps<HTMLElement>

const Tabs = styled.div`
  display: flex;
  ${s({
    height: '56px',
    marginLeft: 6,
    paddingY: 4,
    gap: 8,
  })}
`

const DepartmentTabsContainer = styled.div`
  position: relative;
  z-index: 3;
  top: 48px;
  ${s({
    bgcolor: 'colorBackground01',
  })}
`

const StyledDivider = styled(Divider)`
  ${s({
    marginY: 0,
    bgcolor: 'colorBackgroundDeactivated',
    borderRadius: 0,
  })}
`

export const DepartmentTabs: FC<DepartmentTabsProps> = ({
  selectedDepartment,
  departments,
  highlightedIndex,
  getItemProps,
  storeId,
  setHighlightedIndex,
  setActiveDepartment,
}) => {
  return (
    <DepartmentTabsContainer
      data-testid="department-tabs"
      onMouseLeave={() => setHighlightedIndex(-1)}
    >
      <Tabs>
        {departments.map((department, i) => {
          return (
            <DepartmentTab
              key={department.title}
              selectedDepartment={selectedDepartment}
              department={department}
              highlightedIndex={highlightedIndex}
              index={i}
              getItemProps={getItemProps}
              storeId={storeId}
              setActiveDepartment={setActiveDepartment}
            />
          )
        })}
      </Tabs>
      <StyledDivider />
    </DepartmentTabsContainer>
  )
}
